import React, { useState, useEffect } from 'react';
import { Typography, Grid, Box, CircularProgress, Alert, Button } from '@mui/material';
import OrderCard from '../components/OrderCard'; // Import the OrderCard component
import { useParams, useNavigate } from 'react-router-dom'; // Import useParams and useNavigate
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import back arrow icon

// Mock Data - Replace with API call later
const mockOrders = [
  {
    id: 'ORD-001',
    clickupId: 'task_123',
    projectName: 'Proyecto Alpha',
    status: 'Pendiente Autorización',
    date: '2024-03-27',
    pdfUrl: '#', // Placeholder URL
    pdfHash: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2',
  },
  {
    id: 'ORD-002',
    clickupId: 'task_456',
    projectName: 'Proyecto Beta',
    status: 'Pendiente Autorización',
    date: '2024-03-28',
    pdfUrl: '#',
    pdfHash: 'e5f6g7h8i9j0e5f6g7h8i9j0e5f6g7h8i9j0e5f6g7h8i9j0e5f6g7h8i9j0e5f6',
  },
  {
    id: 'ORD-003',
    clickupId: 'task_789',
    projectName: 'Proyecto Gamma',
    status: 'Autorizada', // Example of different status
    date: '2024-03-25',
    pdfUrl: '#',
    pdfHash: 'i9j0k1l2m3n4i9j0k1l2m3n4i9j0k1l2m3n4i9j0k1l2m3n4i9j0k1l2m3n4i9j0',
  },
    {
    id: 'ORD-004',
    clickupId: 'task_101',
    projectName: 'Proyecto Delta',
    status: 'Pendiente Autorización',
    date: '2024-03-29',
    pdfUrl: null, // Example with no PDF yet
    pdfHash: 'k1l2m3n4o5p6k1l2m3n4o5p6k1l2m3n4o5p6k1l2m3n4o5p6k1l2m3n4o5p6k1l2',
  },
];

function DashboardPage() {
  const { status } = useParams(); // Get status from URL parameter
  const navigate = useNavigate(); // Hook for navigation
  const decodedStatus = status ? decodeURIComponent(status) : undefined;

  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  // Simulate fetching data and filtering by status
  useEffect(() => {
    setIsLoading(true);
    setError('');
    // --- Simulate API Call --- 
    setTimeout(() => {
      try {
        const allOrders = mockOrders; // In real app, fetch only needed orders or all if necessary
        const filtered = decodedStatus
          ? allOrders.filter(order => order.status === decodedStatus)
          : allOrders; // Show all if no status provided (optional)
        
        setOrders(filtered);
        setIsLoading(false);
      } catch(e) {
          console.error("Error processing orders:", e);
          setError('Error al procesar las órdenes.');
          setIsLoading(false);
      }
    }, 500); // Shorter delay for filtering simulation
    // --- Replace above with actual API call --- 

  }, [decodedStatus]); // Re-run effect if the status parameter changes

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Button 
        startIcon={<ArrowBackIcon />} 
        onClick={() => navigate('/')} // Navigate back to summary
        sx={{ mb: 2 }} // Add some margin below
      >
        Volver al Resumen
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        Órdenes: {decodedStatus || 'Todas'}
      </Typography>

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress color="secondary" />
        </Box>
      )}

      {error && (
         <Alert severity="error" sx={{ width: '100%', mt: 2 }}>{error}</Alert>
      )}

      {!isLoading && !error && (
        <Grid container spacing={3}> {/* Grid container */}
          {orders.length > 0 ? (
             orders.map((order) => (
              <Grid item xs={12} sm={6} md={4} key={order.id}> {/* Grid item for each card */}
                <OrderCard order={order} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
                <Typography>No hay órdenes con el estado "{decodedStatus}" para mostrar.</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </Box>
  );
}

export default DashboardPage; 